export default __webpack_public_path__ + "img/506d179307abc4cdf6f673f8c5b1252d.svg";